import { useEffect, useRef } from 'react'

export default function Ppr() {
  const rect1Ref = useRef()
  const rect2Ref = useRef()
  const rect3Ref = useRef()
  const rectLabel1Ref = useRef()
  const rectLabel2Ref = useRef()
  const rectLabel3Ref = useRef()

  useEffect(() => {
    if (rect1Ref.current) {
      rect1Ref.current.beginElement()
    }
  })

  useEffect(() => {
    if (rect2Ref.current) {
      rect2Ref.current.beginElement()
    }
  })

  useEffect(() => {
    if (rect3Ref.current) {
      rect3Ref.current.beginElement()
    }
  })

  useEffect(() => {
    if (rectLabel1Ref.current) {
      rectLabel1Ref.current.beginElement()
    }
  })

  useEffect(() => {
    if (rectLabel2Ref.current) {
      rectLabel2Ref.current.beginElement()
    }
  })

  useEffect(() => {
    if (rectLabel3Ref.current) {
      rectLabel3Ref.current.beginElement()
    }
  })

  return (
    <>
      <g data-test="component-ppr">
        <rect
          x="138.899"
          y="136.841"
          width="58.4706"
          height="361.682"
          rx="6.68235"
          fill="#EEF1FA"
        ></rect>
      </g>
      <g filter="url(#filter7_di_2164_68606)">
        <rect
          x="145.581"
          y="144.359"
          width="45.9412"
          height="103.576"
          rx="6.68235"
          fill="url(#paint0_linear_2164_68606)"
        >
          <animate
            attributeName="height"
            ref={rect1Ref}
            from="0"
            to="103.576"
            dur="0.3s"
            fill="freeze"
          />
        </rect>
      </g>
      <g filter="url(#filter8_di_2164_68606)">
        <rect
          x="145.582"
          y="251.277"
          width="45.9412"
          height="119.447"
          rx="6.68235"
          fill="url(#paint1_linear_2164_68606)"
        >
          <animate
            attributeName="height"
            ref={rect2Ref}
            from="0"
            to="119.447"
            dur="0.3s"
            fill="freeze"
          />
        </rect>
      </g>
      <g filter="url(#filter9_di_2164_68606)">
        <rect
          x="145.582"
          y="374.065"
          width="45.9412"
          height="116.106"
          rx="6.68235"
          fill="url(#paint2_linear_2164_68606)"
        >
          <animate
            attributeName="height"
            ref={rect3Ref}
            from="0"
            to="116.106"
            dur="0.3s"
            fill="freeze"
          />
        </rect>
      </g>
      <g opacity={1}>
        <path
          d="M215.215 188.305C216.134 188.656 217.119 188.773 218.021 188.773C220.577 188.773 222.348 187.42 222.348 185.382C222.348 184.012 221.429 182.976 219.375 182.542C221.012 181.957 222.131 181.055 222.131 179.518C222.131 177.998 220.678 176.812 218.506 176.812C217.337 176.812 216.15 177.213 215.165 177.831L215.699 179.435C216.384 178.917 217.37 178.583 218.222 178.583C219.441 178.583 220.06 179.184 220.06 179.836C220.06 180.788 218.84 181.723 216.317 182.224L216.518 183.528C219.007 183.594 220.227 184.329 220.227 185.482C220.227 186.384 219.291 186.986 217.771 186.986C216.802 186.986 215.883 186.785 214.948 186.468L215.215 188.305ZM224.074 188.305C224.992 188.656 225.978 188.773 226.88 188.773C229.436 188.773 231.207 187.42 231.207 185.382C231.207 184.012 230.288 182.976 228.233 182.542C229.87 181.957 230.99 181.055 230.99 179.518C230.99 177.998 229.536 176.812 227.365 176.812C226.195 176.812 225.009 177.213 224.023 177.831L224.558 179.435C225.243 178.917 226.229 178.583 227.081 178.583C228.3 178.583 228.918 179.184 228.918 179.836C228.918 180.788 227.699 181.723 225.176 182.224L225.377 183.528C227.866 183.594 229.085 184.329 229.085 185.482C229.085 186.384 228.15 186.986 226.63 186.986C225.661 186.986 224.742 186.785 223.806 186.468L224.074 188.305ZM235.939 176.828C234.135 176.828 232.598 179.017 232.598 181.005C232.598 182.308 233.333 183.277 234.653 183.277C236.457 183.277 237.994 181.072 237.994 179.1C237.994 177.797 237.259 176.828 235.939 176.828ZM234.736 181.991C234.285 181.991 234.085 181.64 234.085 181.055C234.085 179.785 234.937 178.098 235.856 178.098C236.307 178.098 236.507 178.432 236.507 179.05C236.507 180.32 235.655 181.991 234.736 181.991ZM234.402 189.057C234.954 188.372 235.304 187.904 235.739 187.353L241.97 179.234C242.404 178.666 243.106 177.747 243.557 177.213C243.307 177.079 242.605 176.661 242.371 176.528C242.02 177.029 241.519 177.697 240.316 179.268L235.438 185.632C234.82 186.451 234.402 186.986 233.233 188.422L234.402 189.057ZM242.204 182.325C240.4 182.325 238.863 184.513 238.863 186.484C238.863 187.788 239.615 188.756 240.918 188.756C242.722 188.756 244.276 186.568 244.276 184.58C244.276 183.277 243.524 182.325 242.204 182.325ZM241.001 187.487C240.55 187.487 240.366 187.136 240.366 186.535C240.366 185.265 241.202 183.594 242.12 183.594C242.588 183.594 242.772 183.928 242.772 184.53C242.772 185.8 241.937 187.487 241.001 187.487Z"
          fill="#1DBC81"
        />
        <path
          d="M254.463 186.249C252.428 186.249 251.025 184.6 251.025 182.518C251.025 180.343 252.498 178.554 254.638 178.554C256.673 178.554 258.076 180.191 258.076 182.284C258.076 184.459 256.614 186.249 254.463 186.249ZM254.439 186.716C256.907 186.716 258.626 184.717 258.626 182.191C258.626 179.981 257.024 178.086 254.673 178.086C252.194 178.086 250.475 180.086 250.475 182.612C250.475 184.81 252.089 186.716 254.439 186.716ZM264.722 186.506C264.722 186.202 264.699 185.711 264.699 185.301V182.927C264.699 181.676 263.974 181.138 263.05 181.138C262.009 181.138 261.167 181.98 260.828 182.53L260.793 181.232C260.618 181.255 260.466 181.267 260.279 181.267C260.314 181.77 260.337 182.588 260.337 183.267V184.518C260.337 185.196 260.314 186.003 260.29 186.506H260.863C260.852 186.12 260.84 185.711 260.84 185.301V183.313C260.84 182.752 261.892 181.594 262.898 181.594C263.67 181.594 264.196 182.015 264.196 183.091V184.518C264.196 185.196 264.173 186.003 264.149 186.506H264.722ZM271.367 185.933C271.157 186.061 270.888 186.19 270.549 186.19C270.046 186.19 269.742 185.933 269.742 185.313V181.7H271.227C271.227 181.501 271.239 181.396 271.262 181.255H269.742V179.957L269.309 180.062L269.239 181.255H268.491L268.339 181.7H269.227V185.395C269.227 186.19 269.625 186.658 270.432 186.658C270.829 186.658 271.134 186.541 271.344 186.389L271.367 185.933ZM275.182 181.138C274.165 181.22 273.568 181.933 273.288 182.577L273.217 181.208C273.065 181.244 272.867 181.29 272.703 181.302C272.761 181.793 272.796 182.506 272.796 183.185V184.518C272.796 185.196 272.785 186.003 272.75 186.506H273.323C273.311 186.12 273.299 185.711 273.299 185.301V183.536C273.299 182.67 274.094 181.688 275.112 181.723L275.182 181.138ZM277.436 186.634C278.29 186.634 279.027 186.12 279.307 185.418C279.26 186.377 279.623 186.588 280.009 186.588C280.231 186.588 280.418 186.518 280.558 186.424L280.594 186.038C280.465 186.108 280.301 186.178 280.149 186.178C279.88 186.178 279.74 186.026 279.752 185.477L279.822 183.161C279.857 181.805 279.132 181.138 277.997 181.138C277.378 181.138 276.816 181.325 276.267 181.641L276.395 182.109C276.816 181.828 277.378 181.594 277.939 181.594C278.874 181.594 279.342 182.144 279.319 183.267L279.307 183.547C279.05 183.524 278.793 183.5 278.477 183.5C276.547 183.5 275.846 184.284 275.846 185.184C275.846 185.991 276.395 186.634 277.436 186.634ZM277.541 186.202C276.711 186.202 276.36 185.711 276.36 185.149C276.36 184.506 276.828 183.875 278.465 183.875C278.722 183.875 279.015 183.886 279.295 183.921L279.272 184.436C279.237 185.453 278.477 186.202 277.541 186.202ZM285.887 181.664C285.536 181.384 284.928 181.138 284.203 181.138C282.519 181.138 281.443 182.448 281.443 184.015C281.443 185.547 282.495 186.681 284.097 186.681C284.846 186.681 285.372 186.471 285.898 186.097L285.922 185.524C285.442 185.945 284.881 186.214 284.156 186.214C282.893 186.214 281.946 185.36 281.946 183.945C281.946 182.705 282.799 181.606 284.179 181.606C284.834 181.606 285.384 181.863 285.723 182.144L285.887 181.664ZM291.072 186.634L291.645 186.494C291.47 186.319 289.482 184.518 289.271 184.284L288.558 183.629L291.376 181.22C291.189 181.232 290.874 181.244 290.663 181.244C290.558 181.384 288.429 183.161 287.997 183.571V179.56C287.997 178.998 288.009 178.226 288.02 178.133C287.856 178.156 287.623 178.18 287.447 178.191C287.482 178.776 287.494 179.291 287.494 180.203V184.541C287.494 185.22 287.482 186.003 287.447 186.506H288.02C288.009 186.202 287.997 185.734 287.997 185.325V183.734L291.072 186.634Z"
          fill="#1C1C1C"
        />
        <animate
          attributeName="opacity"
          ref={rectLabel1Ref}
          from="0"
          to="1"
          dur="0.3s"
        />
      </g>
      <g opacity={1}>
        <path
          d="M215.176 323.482C216.095 323.832 217.081 323.949 217.983 323.949C220.539 323.949 222.31 322.596 222.31 320.558C222.31 319.188 221.391 318.152 219.336 317.718C220.973 317.133 222.093 316.231 222.093 314.694C222.093 313.174 220.639 311.988 218.468 311.988C217.298 311.988 216.112 312.389 215.126 313.007L215.661 314.611C216.346 314.093 217.332 313.759 218.184 313.759C219.403 313.759 220.021 314.36 220.021 315.012C220.021 315.964 218.802 316.9 216.279 317.401L216.48 318.704C218.969 318.771 220.188 319.506 220.188 320.658C220.188 321.56 219.253 322.162 217.732 322.162C216.764 322.162 215.845 321.961 214.909 321.644L215.176 323.482ZM228.863 323.682H230.985C230.951 323.298 230.935 322.262 230.935 321.761V320.742L232.605 320.792C232.605 320.09 232.655 319.723 232.739 319.088C232.338 319.121 231.703 319.121 230.935 319.121V314.06C230.935 313.441 230.951 312.589 230.985 312.105L229.364 311.971C229.08 312.339 228.579 313.007 228.128 313.575L223.484 319.405L223.801 320.792C224.937 320.742 226.758 320.725 228.111 320.725H228.947V321.093C228.947 321.844 228.93 323.148 228.863 323.682ZM225.672 319.172L229.014 315.012L228.98 319.172H225.672ZM236.978 312.005C235.173 312.005 233.636 314.193 233.636 316.181C233.636 317.484 234.372 318.453 235.691 318.453C237.496 318.453 239.032 316.248 239.032 314.277C239.032 312.974 238.297 312.005 236.978 312.005ZM235.775 317.167C235.324 317.167 235.123 316.816 235.123 316.231C235.123 314.962 235.975 313.274 236.894 313.274C237.345 313.274 237.546 313.608 237.546 314.227C237.546 315.496 236.694 317.167 235.775 317.167ZM235.441 324.233C235.992 323.548 236.343 323.081 236.777 322.529L243.008 314.41C243.443 313.842 244.144 312.924 244.596 312.389C244.345 312.255 243.643 311.838 243.409 311.704C243.059 312.205 242.557 312.873 241.355 314.444L236.476 320.809C235.858 321.627 235.441 322.162 234.271 323.599L235.441 324.233ZM243.242 317.501C241.438 317.501 239.901 319.689 239.901 321.661C239.901 322.964 240.653 323.933 241.956 323.933C243.76 323.933 245.314 321.744 245.314 319.756C245.314 318.453 244.562 317.501 243.242 317.501ZM242.04 322.663C241.588 322.663 241.405 322.312 241.405 321.711C241.405 320.441 242.24 318.771 243.159 318.771C243.627 318.771 243.81 319.105 243.81 319.706C243.81 320.976 242.975 322.663 242.04 322.663Z"
          fill="#FDB515"
        />
        <path
          d="M256.333 313.403C255.655 313.438 254.859 313.449 254.088 313.449C253.339 313.449 252.556 313.438 251.924 313.403C251.959 313.964 251.971 315.531 251.971 316.279V318.864C251.971 319.624 251.959 321.121 251.924 321.682H252.521C252.509 321.355 252.509 320.443 252.509 319.998V317.718L255.643 317.73C255.643 317.554 255.655 317.39 255.678 317.25H252.509V315.122C252.509 314.829 252.509 314.28 252.521 313.917C252.836 313.906 253.772 313.906 254.088 313.906C254.883 313.906 255.608 313.917 256.274 313.917C256.274 313.718 256.286 313.59 256.333 313.403ZM262.034 318.946C262.034 317.449 261.017 316.315 259.485 316.315C257.848 316.315 256.795 317.577 256.795 319.215C256.795 320.712 257.813 321.858 259.333 321.858C260.982 321.858 262.034 320.583 262.034 318.946ZM261.531 319.028C261.531 320.337 260.678 321.39 259.38 321.39C258.163 321.39 257.298 320.536 257.298 319.121C257.298 317.835 258.163 316.771 259.438 316.771C260.608 316.771 261.531 317.589 261.531 319.028ZM266.008 316.315C264.991 316.396 264.395 317.11 264.114 317.753L264.044 316.385C263.892 316.42 263.693 316.467 263.529 316.478C263.588 316.969 263.623 317.683 263.623 318.361V319.694C263.623 320.372 263.611 321.179 263.576 321.682H264.149C264.137 321.296 264.126 320.887 264.126 320.478V318.712C264.126 317.846 264.921 316.864 265.938 316.899L266.008 316.315ZM270.775 321.811C271.629 321.811 272.365 321.296 272.646 320.595C272.599 321.553 272.962 321.764 273.348 321.764C273.57 321.764 273.757 321.694 273.897 321.6L273.932 321.214C273.804 321.285 273.64 321.355 273.488 321.355C273.219 321.355 273.079 321.203 273.09 320.653L273.161 318.338C273.196 316.981 272.471 316.315 271.336 316.315C270.717 316.315 270.155 316.502 269.606 316.817L269.734 317.285C270.155 317.004 270.717 316.771 271.278 316.771C272.213 316.771 272.681 317.32 272.658 318.443L272.646 318.724C272.389 318.7 272.132 318.677 271.816 318.677C269.886 318.677 269.185 319.46 269.185 320.361C269.185 321.168 269.734 321.811 270.775 321.811ZM270.88 321.378C270.05 321.378 269.699 320.887 269.699 320.326C269.699 319.682 270.167 319.051 271.804 319.051C272.061 319.051 272.354 319.063 272.634 319.098L272.611 319.612C272.576 320.63 271.816 321.378 270.88 321.378ZM277.542 321.109C277.332 321.238 277.063 321.366 276.724 321.366C276.221 321.366 275.917 321.109 275.917 320.489V316.876H277.402C277.402 316.677 277.414 316.572 277.437 316.431H275.917V315.133L275.484 315.239L275.414 316.431H274.666L274.514 316.876H275.402V320.571C275.402 321.366 275.8 321.834 276.607 321.834C277.005 321.834 277.309 321.717 277.519 321.565L277.542 321.109ZM281.311 321.109C281.101 321.238 280.832 321.366 280.492 321.366C279.99 321.366 279.686 321.109 279.686 320.489V316.876H281.171C281.171 316.677 281.182 316.572 281.206 316.431H279.686V315.133L279.253 315.239L279.183 316.431H278.434L278.282 316.876H279.171V320.571C279.171 321.366 279.569 321.834 280.376 321.834C280.773 321.834 281.077 321.717 281.288 321.565L281.311 321.109ZM287.009 318.782C287.009 317.39 286.296 316.315 284.881 316.315C283.326 316.315 282.285 317.589 282.285 319.226C282.285 320.712 283.255 321.858 284.787 321.858C285.688 321.858 286.284 321.542 286.787 321.168L286.81 320.618C286.296 321.051 285.699 321.39 284.869 321.39C283.63 321.39 282.788 320.571 282.799 319.109L286.647 319.016L287.009 318.782ZM282.823 318.7C282.975 317.648 283.723 316.759 284.822 316.759C285.851 316.759 286.436 317.449 286.518 318.607L282.823 318.7ZM292.938 321.682C292.938 321.378 292.915 320.887 292.915 320.478V318.104C292.915 316.852 292.19 316.315 291.266 316.315C290.225 316.315 289.383 317.157 289.044 317.706L289.009 316.408C288.833 316.431 288.681 316.443 288.494 316.443C288.529 316.946 288.553 317.765 288.553 318.443V319.694C288.553 320.372 288.529 321.179 288.506 321.682H289.079C289.067 321.296 289.056 320.887 289.056 320.478V318.49C289.056 317.928 290.108 316.771 291.114 316.771C291.886 316.771 292.412 317.192 292.412 318.267V319.694C292.412 320.372 292.388 321.179 292.365 321.682H292.938ZM297.231 321.109C297.02 321.238 296.751 321.366 296.412 321.366C295.909 321.366 295.605 321.109 295.605 320.489V316.876H297.09C297.09 316.677 297.102 316.572 297.125 316.431H295.605V315.133L295.172 315.239L295.102 316.431H294.354L294.202 316.876H295.091V320.571C295.091 321.366 295.488 321.834 296.295 321.834C296.693 321.834 296.997 321.717 297.207 321.565L297.231 321.109ZM299.186 321.682C299.174 321.378 299.162 320.91 299.162 320.501V317.811C299.162 317.694 299.174 316.49 299.186 316.396C299.01 316.42 298.788 316.431 298.601 316.431C298.636 316.934 298.66 317.788 298.66 318.466V319.718C298.66 320.396 298.648 321.179 298.613 321.682H299.186ZM299.326 314.607C299.326 314.397 299.174 314.21 298.929 314.21C298.671 314.21 298.496 314.397 298.496 314.631C298.496 314.841 298.66 315.04 298.905 315.04C299.162 315.04 299.326 314.841 299.326 314.607ZM305.956 318.946C305.956 317.449 304.938 316.315 303.406 316.315C301.769 316.315 300.717 317.577 300.717 319.215C300.717 320.712 301.734 321.858 303.254 321.858C304.903 321.858 305.956 320.583 305.956 318.946ZM305.453 319.028C305.453 320.337 304.599 321.39 303.301 321.39C302.085 321.39 301.22 320.536 301.22 319.121C301.22 317.835 302.085 316.771 303.36 316.771C304.529 316.771 305.453 317.589 305.453 319.028ZM311.93 321.682C311.93 321.378 311.906 320.887 311.906 320.478V318.104C311.906 316.852 311.181 316.315 310.257 316.315C309.217 316.315 308.375 317.157 308.035 317.706L308 316.408C307.825 316.431 307.673 316.443 307.486 316.443C307.521 316.946 307.544 317.765 307.544 318.443V319.694C307.544 320.372 307.521 321.179 307.498 321.682H308.071C308.059 321.296 308.047 320.887 308.047 320.478V318.49C308.047 317.928 309.1 316.771 310.105 316.771C310.877 316.771 311.403 317.192 311.403 318.267V319.694C311.403 320.372 311.38 321.179 311.357 321.682H311.93Z"
          fill="#1C1C1C"
        />
        <animate
          attributeName="opacity"
          ref={rectLabel2Ref}
          from="0"
          to="1"
          dur="0.3s"
        />
      </g>
      <g opacity={1}>
        <path
          d="M215.215 458.658C216.134 459.009 217.119 459.126 218.021 459.126C220.577 459.126 222.348 457.773 222.348 455.735C222.348 454.365 221.429 453.329 219.375 452.895C221.012 452.31 222.131 451.408 222.131 449.871C222.131 448.351 220.678 447.165 218.506 447.165C217.337 447.165 216.15 447.566 215.165 448.184L215.699 449.788C216.384 449.27 217.37 448.936 218.222 448.936C219.441 448.936 220.06 449.537 220.06 450.189C220.06 451.141 218.84 452.076 216.317 452.577L216.518 453.881C219.007 453.947 220.227 454.682 220.227 455.835C220.227 456.737 219.291 457.339 217.771 457.339C216.802 457.339 215.883 457.138 214.948 456.821L215.215 458.658ZM224.074 458.658C224.992 459.009 225.978 459.126 226.88 459.126C229.436 459.126 231.207 457.773 231.207 455.735C231.207 454.365 230.288 453.329 228.233 452.895C229.87 452.31 230.99 451.408 230.99 449.871C230.99 448.351 229.536 447.165 227.365 447.165C226.195 447.165 225.009 447.566 224.023 448.184L224.558 449.788C225.243 449.27 226.229 448.936 227.081 448.936C228.3 448.936 228.918 449.537 228.918 450.189C228.918 451.141 227.699 452.076 225.176 452.577L225.377 453.881C227.866 453.947 229.085 454.682 229.085 455.835C229.085 456.737 228.15 457.339 226.63 457.339C225.661 457.339 224.742 457.138 223.806 456.821L224.074 458.658ZM235.939 447.181C234.135 447.181 232.598 449.37 232.598 451.358C232.598 452.661 233.333 453.63 234.653 453.63C236.457 453.63 237.994 451.425 237.994 449.453C237.994 448.15 237.259 447.181 235.939 447.181ZM234.736 452.344C234.285 452.344 234.085 451.993 234.085 451.408C234.085 450.138 234.937 448.451 235.856 448.451C236.307 448.451 236.507 448.785 236.507 449.403C236.507 450.673 235.655 452.344 234.736 452.344ZM234.402 459.41C234.954 458.725 235.304 458.257 235.739 457.706L241.97 449.587C242.404 449.019 243.106 448.1 243.557 447.566C243.307 447.432 242.605 447.014 242.371 446.881C242.02 447.382 241.519 448.05 240.316 449.621L235.438 455.985C234.82 456.804 234.402 457.339 233.233 458.775L234.402 459.41ZM242.204 452.678C240.4 452.678 238.863 454.866 238.863 456.837C238.863 458.141 239.615 459.109 240.918 459.109C242.722 459.109 244.276 456.921 244.276 454.933C244.276 453.63 243.524 452.678 242.204 452.678ZM241.001 457.84C240.55 457.84 240.366 457.489 240.366 456.888C240.366 455.618 241.202 453.947 242.12 453.947C242.588 453.947 242.772 454.281 242.772 454.883C242.772 456.153 241.937 457.84 241.001 457.84Z"
          fill="#F71831"
        />
        <path
          d="M249.928 456.859H250.548C250.63 456.648 251.051 455.561 251.425 454.707L251.752 453.924H255.588L256.909 456.929L257.494 456.859C257.389 456.648 256.968 455.725 256.559 454.812L253.74 448.451L253.565 448.486C253.343 449.094 253.039 449.772 252.501 451.024L249.928 456.859ZM253.67 449.492L255.377 453.456H251.963L253.67 449.492ZM260.954 456.286C260.743 456.415 260.474 456.543 260.135 456.543C259.632 456.543 259.328 456.286 259.328 455.666V452.053H260.813C260.813 451.854 260.825 451.749 260.848 451.608H259.328V450.31L258.895 450.415L258.825 451.608H258.077L257.925 452.053H258.814V455.748C258.814 456.543 259.211 457.011 260.018 457.011C260.416 457.011 260.72 456.894 260.93 456.742L260.954 456.286ZM267.086 451.491C266.069 451.573 265.473 452.286 265.192 452.93L265.122 451.561C264.97 451.597 264.771 451.643 264.607 451.655C264.666 452.146 264.701 452.859 264.701 453.538V454.871C264.701 455.549 264.689 456.356 264.654 456.859H265.227C265.215 456.473 265.204 456.064 265.204 455.654V453.889C265.204 453.023 265.999 452.041 267.016 452.076L267.086 451.491ZM268.95 456.859C268.938 456.555 268.927 456.087 268.927 455.678V452.988C268.927 452.871 268.938 451.667 268.95 451.573C268.775 451.597 268.552 451.608 268.365 451.608C268.4 452.111 268.424 452.965 268.424 453.643V454.894C268.424 455.573 268.412 456.356 268.377 456.859H268.95ZM269.09 449.784C269.09 449.573 268.938 449.386 268.693 449.386C268.435 449.386 268.26 449.573 268.26 449.807C268.26 450.018 268.424 450.217 268.669 450.217C268.927 450.217 269.09 450.018 269.09 449.784ZM272.317 451.491C271.335 451.491 270.586 452.088 270.586 452.906C270.586 454.532 273.44 454.216 273.44 455.491C273.44 456.181 272.796 456.555 272.083 456.555C271.44 456.555 270.878 456.333 270.446 456.04L270.399 456.602C270.808 456.847 271.44 457.023 272.06 457.023C273.042 457.023 273.966 456.45 273.966 455.432C273.966 453.83 271.101 454.099 271.101 452.883C271.101 452.31 271.639 451.959 272.305 451.959C272.831 451.959 273.241 452.123 273.58 452.357L273.755 451.877C273.44 451.69 272.96 451.491 272.317 451.491ZM279.128 456.988L279.701 456.847C279.526 456.672 277.538 454.871 277.327 454.637L276.614 453.982L279.432 451.573C279.245 451.585 278.929 451.597 278.719 451.597C278.614 451.737 276.485 453.514 276.053 453.924V449.913C276.053 449.351 276.064 448.579 276.076 448.486C275.912 448.509 275.678 448.533 275.503 448.544C275.538 449.129 275.55 449.644 275.55 450.556V454.894C275.55 455.573 275.538 456.356 275.503 456.859H276.076C276.064 456.555 276.053 456.087 276.053 455.678V454.087L279.128 456.988Z"
          fill="#1C1C1C"
        />
        <animate
          attributeName="opacity"
          ref={rectLabel3Ref}
          from="0"
          to="1"
          dur="0.3s"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2164_68606"
          x="66.7578"
          y="63.1313"
          width="317.502"
          height="495.788"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.7625 0 0 0 0 0.749792 0 0 0 0 0.749792 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_68606"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_68606"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2164_68606"
          x="85.9111"
          y="82.3521"
          width="279.444"
          height="458.567"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.556863 0 0 0 0 0.792157 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_68606"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_68606"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_2164_68606"
          x="68.8994"
          y="63.1313"
          width="317.502"
          height="495.788"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="11" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.7625 0 0 0 0 0.749792 0 0 0 0 0.749792 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_68606"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_68606"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_2164_68606"
          x="87.8047"
          y="82.3521"
          width="279.444"
          height="458.567"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.556863 0 0 0 0 0.792157 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_68606"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_68606"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_f_2164_68606"
          x="0.485558"
          y="0.0104599"
          width="452.313"
          height="623.56"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="47.7865"
            result="effect1_foregroundBlur_2164_68606"
          />
        </filter>
        <filter
          id="filter5_bd_2164_68606"
          x="107.199"
          y="90.8354"
          width="237.52"
          height="442.25"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="2" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2164_68606"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.556863 0 0 0 0 0.792157 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_backgroundBlur_2164_68606"
            result="effect2_dropShadow_2164_68606"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_2164_68606"
            result="shape"
          />
        </filter>
        <filter
          id="filter6_d_2164_68606"
          x="111.199"
          y="94.8354"
          width="229.52"
          height="434.25"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0509804 0 0 0 0 0.556863 0 0 0 0 0.792157 0 0 0 0.22 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_68606"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_68606"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_di_2164_68606"
          x="140.569"
          y="139.347"
          width="55.9649"
          height="113.6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.50588" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.658824 0 0 0 0 0.733333 0 0 0 0 0 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_68606"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_68606"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.17647" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.658824 0 0 0 0 0.733333 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_2164_68606"
          />
        </filter>
        <filter
          id="filter8_di_2164_68606"
          x="140.57"
          y="246.265"
          width="55.9649"
          height="129.471"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.50588" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.992157 0 0 0 0 0.709804 0 0 0 0 0.0823529 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_68606"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_68606"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.17647" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.992157 0 0 0 0 0.709804 0 0 0 0 0.0823529 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_2164_68606"
          />
        </filter>
        <filter
          id="filter9_di_2164_68606"
          x="140.57"
          y="369.053"
          width="55.9649"
          height="126.129"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.50588" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.913725 0 0 0 0 0.32549 0 0 0 0 0.168627 0 0 0 0.3 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2164_68606"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2164_68606"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4.17647" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.913725 0 0 0 0 0.32549 0 0 0 0 0.168627 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_2164_68606"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2164_68606"
          x1="148.685"
          y1="171.303"
          x2="197.677"
          y2="183.356"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1BAE79" />
          <stop offset="1" stopColor="#21D993" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2164_68606"
          x1="148.686"
          y1="282.349"
          x2="198.382"
          y2="292.951"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEBF44" />
          <stop offset="1" stopColor="#FED17A" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2164_68606"
          x1="148.686"
          y1="404.268"
          x2="198.256"
          y2="415.148"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5001D" />
          <stop offset="1" stopColor="#FF8795" />
        </linearGradient>
      </defs>
    </>
  )
}
